import CiudadPage from './page';
import DepartmentForm from './departmentForm';
// import PanelClient from './panelClient';

export { DepartmentForm };
export default CiudadPage;
